import { appActionTypes } from 'application/appActions';
import { combineReducers, } from 'redux';
import { watchFetchDataSaga } from 'jsCore/application/sagas/fetchSaga';
const appSagas = [ watchFetchDataSaga ];


const APP_REDUCER_INITIAL_STATE = {
  mountedComponents: [],
  reducers: {},
  sagas: appSagas
};

function setState(state, componentObj){
  const { component, name: componentName, sagas = [] } = componentObj;
  const newState = {
    mountedComponents: [
      ...state.mountedComponents,
      {
        [componentName]: component,
      },
    ],
    sagas: [
      ...state.sagas,
      ...sagas
    ]
  };
  return { ...state, ...newState, };
}

function registerReducer(state, newState){
  const newConstructedState = {
    ...state.reducers,
    ...newState,
  };
  return {
    ...state,
    ...{
      reducers: newConstructedState,
    },
  };
}

export function appReducer(state = APP_REDUCER_INITIAL_STATE, action){
  switch (action.type) {
    case appActionTypes.COMPONENT_MOUNT:
      return setState(state, action.state);
    case appActionTypes.REGISTER_REDUCER:
      return registerReducer(state, action.state);
    default:
  }
  return state;
}

export default combineReducers({ appReducer, });



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/rootReducer.js